import GeneralDetails from './GeneralDetails';

export default {
  title: 'General Details',
  description:
    'Please fill in the general details that are needed to start using POS.',
  path: '/setup/general',
  rootPath: { name: 'General Setup', uri: '/setup' },
  subPath: [{ name: 'General Details' }],
  component: GeneralDetails,
};
